import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=2fb8b631&scoped=true"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"
import style0 from "./Authentication.vue?vue&type=style&index=0&id=2fb8b631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb8b631",
  null
  
)

export default component.exports